import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },

    resources: {
      // ============================
      // 🇺🇸 ENGLISH TRANSLATION
      // ============================
      en: {
        translation: {
          // Gallery
          gallery: {
            title: "Gallery",
          },

          // RoomCard
          roomCard: {
            explore: "Explore",
          },

          // Navbar
          nav: {
            home: "Home",
            about: "About",
            rooms: "Rooms",
            gallery: "Gallery",
            contact: "Contact Us",
          },

          // Contact form
          contactForm: {
            heading: "Contact Us",
            subheading: "For inquiries or bookings, please fill in the form below:",
            name: "Name",
            email: "Email",
            subject: "Subject",
            message: "Message",
            send: "Send",
          },

          // Footer
          footer: {
            contactHeading: "Contact",
            linksHeading: "Links",
            location: "Location",
            copyright: "Sevasti Country House. All rights reserved.",
          },

          // Home hero
          home: {
            welcomeTo: "Welcome to",
            scrollDown: "Scroll",
          },

          // Rooms page
          roomsPage: {
            viewPhotos: "View Photos",
            limitedAvailability: "LIMITED AVAILABILITY",
            room1: {
              title: "Bright Modern Apartment with Garden Access",
              description:
                "A fresh, modern space with white tones and minimalist design. It offers direct garden access and a large sunrise-facing window. Perfect for guests who enjoy natural light.",
              amenities: [
                "Direct garden access",
                "Large sunrise window",
                "Fully equipped kitchen",
                "Washing machine",
                "Modern white interior",
                "Fireplace",
                "Cozy layout",
              ],
            },
            room2: {
              title: "Cozy First-Floor Apartment with Balcony",
              description:
                "A warm and inviting apartment with a wooden, cabin-like aesthetic. It features a fireplace, a fully equipped kitchen, and a large balcony that brings in natural light. Ideal for couples.",
              amenities: [
                "Big private balcony",
                "Fireplace",
                "Fully equipped kitchen",
                "Wooden interior elements",
                "Cozy lighting",
                "1st floor",
                "Ideal for couples",
              ],
            },
            room3: {
              title: "Spacious Premium Apartment with Extra Comforts",
              description:
                "A larger apartment with very limited availability. It includes a big flat-screen TV, a liquor area, a spacious bathroom, and additional amenities for a premium stay.",
              amenities: [
                "Large flat-screen TV",
                "Liquor area / mini bar",
                "Spacious bathroom",
                "Washing machine",
                "Fully equipped kitchen",
                "Ample interior space",
                "Comfortable seating area",
              ],
            },
          },

          // Home page texts
          experience:
            "Our cozy apartments near Mount Olympus are surrounded by nature, fresh air, and beautiful views. Whether you're here to relax, explore the mountains, or just enjoy the quiet, Sevastí Country House feels like home.",
          nestled:
            "Nestled near Mount Olympus, Sevastí Country House offers the perfect escape from city life.",
          discover:
            "Discover the charm of our village and unwind in comfort.",

          ideal: "Ideal for",
          families: "Families",
          couples: "Couples",
          beach: "Beach lovers",
          hike: "Hiking enthusiasts",
          digital: "Digital nomads",
          nature: "Nature lovers",

          // Apartments section
          ourooms: "Our Rooms",

          apartment1_name: "Bright Modern Apartment with Garden Access",
          apartment2_name: "Cozy Apartment with Balcony",
          apartment3_name: "Spacious Premium Apartment with Extra Comforts",

          apartment1_desc:
            "A cozy apartment with warm wooden tones, a large balcony, and a relaxing atmosphere.",
          apartment2_desc:
            "A modern apartment with direct garden access and a bright sunrise-facing window.",
          apartment3_desc:
            "A spacious premium apartment with full amenities and views of Mount Olympus.",

          // About us section
          about: {
            title: "About Us",
            descHome: "Nestled in a peaceful village near Katerini, Sevasti Country House invites you to unwind in a tranquil setting surrounded by greenery. Enjoy sunny mornings on the spacious terrace, relax in the lush garden, or make the most of the cozy outdoor seating and picnic areas.",
            intro:
              "Welcome to Sevasti Country House – Your Nature Retreat Near Katerini",
            description:
              "Nestled in a peaceful village near Katerini, Sevasti Country House invites you to unwind in a tranquil environment surrounded by greenery. Enjoy quiet mornings on the terrace and peaceful evenings in the garden.",
            description2:
              "Our home offers free private parking, an electric vehicle charging station, and comfortable amenities including a fireplace, washing machine, and barbecue area.",
            description3:
              "Whether you're seeking adventure or a peaceful stay, Sevasti Country House is the perfect starting point for exploring Northern Greece.",

            attractions: {
              title: "Nearby Attractions",

              beach: {
                title: "Paralia Katerinis",
                description:
                  "A popular beach destination only 15 minutes away — perfect for swimming, sunset walks, and seaside dining.",
              },
              olympus: {
                title: "Mount Olympus",
                description:
                  "Greece’s most iconic mountain — ideal for hiking, exploring nature, and visiting nearby villages.",
              },
              dion: {
                title: "Archaeological Museum of Dion",
                description:
                  "Explore ancient Macedonian history in this excellent museum and the surrounding archaeological park.",
              },
              parks: {
                title: "Local Nature Parks",
                description:
                  "Sevasti is surrounded by nature — perfect for walking, birdwatching, or simply relaxing.",
              },
              vergina: {
                title: "Royal Tombs of Vergina",
                description:
                  "Visit the resting place of Philip II of Macedon — a UNESCO World Heritage site.",
              },
            },
          },
        },
      },

      // ============================
      // 🇬🇷 GREEK TRANSLATION
      // ============================
      el: {
        translation: {
          // Gallery
          gallery: {
            title: "Γκαλερί",
          },

          // RoomCard
          roomCard: {
            explore: "Εξερεύνηση",
          },

          // Navbar
          nav: {
            home: "Αρχική",
            about: "Σχετικά",
            rooms: "Δωμάτια",
            gallery: "Γκαλερί",
            contact: "Επικοινωνία",
          },

          // Contact form
          contactForm: {
            heading: "Επικοινωνήστε μαζί μας",
            subheading: "Για πληροφορίες ή κρατήσεις, συμπληρώστε την παρακάτω φόρμα:",
            name: "Όνομα",
            email: "Email",
            subject: "Θέμα",
            message: "Μήνυμα",
            send: "Αποστολή",
          },

          // Footer
          footer: {
            contactHeading: "Επικοινωνία",
            linksHeading: "Σύνδεσμοι",
            location: "Τοποθεσία",
            copyright: "Sevasti Country House. Όλα τα δικαιώματα διατηρούνται.",
          },

          // Home hero
          home: {
            welcomeTo: "Καλώς ήρθατε στο",
            scrollDown: "Κύλιση",
          },

          // Rooms page
          roomsPage: {
            viewPhotos: "Δείτε Φωτογραφίες",
            limitedAvailability: "ΠΕΡΙΟΡΙΣΜΈΝΗ ΔΙΑΘΕΣΙΜΌΤΗΤΑ",
            room1: {
              title: "Φωτεινό Μοντέρνο Διαμέρισμα με Πρόσβαση στον Κήπο",
              description:
                "Ένας φρέσκος, μοντέρνος χώρος με λευκές αποχρώσεις και μινιμαλιστική διακόσμηση. Προσφέρει άμεση πρόσβαση στον κήπο και μεγάλο παράθυρο με θέα την ανατολή. Ιδανικό για επισκέπτες που αγαπούν το φυσικό φως.",
              amenities: [
                "Άμεση πρόσβαση στον κήπο",
                "Μεγάλο παράθυρο με ανατολή",
                "Πλήρως εξοπλισμένη κουζίνα",
                "Πλυντήριο ρούχων",
                "Μοντέρνο λευκό εσωτερικό",
                "Τζάκι",
                "Ζεστή διάταξη",
              ],
            },
            room2: {
              title: "Ζεστό Διαμέρισμα 1ου Ορόφου με Μπαλκόνι",
              description:
                "Ένα ζεστό και φιλόξενο διαμέρισμα με ξύλινη, καμπινοειδή αισθητική. Διαθέτει τζάκι, πλήρως εξοπλισμένη κουζίνα και μεγάλο μπαλκόνι που φέρνει φυσικό φως. Ιδανικό για ζευγάρια.",
              amenities: [
                "Μεγάλο ιδιωτικό μπαλκόνι",
                "Τζάκι",
                "Πλήρως εξοπλισμένη κουζίνα",
                "Ξύλινα στοιχεία εσωτερικού",
                "Ζεστός φωτισμός",
                "1ος όροφος",
                "Ιδανικό για ζευγάρια",
              ],
            },
            room3: {
              title: "Ευρύχωρο Premium Διαμέρισμα με Επιπλέον Παροχές",
              description:
                "Ένα μεγαλύτερο διαμέρισμα με πολύ περιορισμένη διαθεσιμότητα. Περιλαμβάνει μεγάλη τηλεόραση, mini bar, ευρύχωρο μπάνιο και πρόσθετες παροχές για premium διαμονή.",
              amenities: [
                "Μεγάλη οθόνη τηλεόρασης",
                "Μπαρ ποτών / mini bar",
                "Ευρύχωρο μπάνιο",
                "Πλυντήριο ρούχων",
                "Πλήρως εξοπλισμένη κουζίνα",
                "Άφθονος εσωτερικός χώρος",
                "Άνετη περιοχή καθιστικού",
              ],
            },
          },

          // Home page texts
          experience:
            "Ζήστε τη γαλήνη της φύσης, με καθαρό αέρα, όμορφη θέα και άνεση. Είτε θέλετε να χαλαρώσετε είτε να εξερευνήσετε τον Όλυμπο, το Sevastí Country House σας κάνει να νιώθετε σαν στο σπίτι σας.",
          nestled:
            "Φωλιασμένο κοντά στον Όλυμπο, το Sevastí Country House προσφέρει την τέλεια απόδραση από τη ζωή της πόλης.",
          discover:
            "Ανακαλύψτε τη γοητεία του χωριού μας και χαλαρώστε με άνεση.",

          ideal: "Ιδανικό για",
          families: "Οικογένειες",
          couples: "Ζευγάρια",
          beach: "Λάτρεις της παραλίας",
          hike: "Πεζοπόρους",
          digital: "Ψηφιακούς νομάδες",
          nature: "Λάτρεις της φύσης",

          // Apartments section
          ourooms: "Διαθέσιμα Δωμάτια",

          apartment1_name: "Φωτεινό Μοντέρνο Διαμέρισμα με Κήπο",
          apartment2_name: "Ζεστό Διαμέρισμα με Μπαλκόνι",
          apartment3_name: "Ευρύχωρο Διαμέρισμα με Επιπλέον Παροχές",

          apartment1_desc:
            "Ζεστό διαμέρισμα με ξύλινη αίσθηση, μεγάλο μπαλκόνι και χαλαρή ατμόσφαιρα.",
          apartment2_desc:
            "Μοντέρνο διαμέρισμα με άμεση πρόσβαση στον κήπο και φωτεινό παράθυρο με ανατολή.",
          apartment3_desc:
            "Ευρύχωρο premium διαμέρισμα, πλήρως εξοπλισμένο, με θέα προς τον Όλυμπο.",

          // About us section
          about: {
            title: "Σχετικά με εμάς",
            descHome: "Φωλιασμένο σε ένα ήσυχο χωριό κοντά στην Κατερίνη, το Sevasti Country House σας προσκαλεί να χαλαρώσετε σε ένα ήρεμο περιβάλλον περιτριγυρισμένο από πράσινο. Απολαύστε ηλιόλουστα πρωινά στη μεγάλη βεράντα, χαλαρώστε στον καταπράσινο κήπο ή εκμεταλλευτείτε τους άνετους εξωτερικούς χώρους και τις περιοχές για πικνίκ.",
            intro:
              "Καλώς ήρθατε στο Sevasti Country House – Το καταφύγιό σας στη φύση, κοντά στην Κατερίνη.",
            description:
              "Χτισμένο στο ήσυχο χωριό Σεβαστή, το κατάλυμά μας προσφέρει γαλήνη και άνεση, περιτριγυρισμένο από πράσινο. Απολαύστε πρωινό στην αυλή και χαλαρώστε στον όμορφο κήπο.",
            description2:
              "Παρέχουμε δωρεάν ιδιωτικό πάρκινγκ, σταθμό φόρτισης ηλεκτρικών αυτοκινήτων και άνετες παροχές όπως τζάκι, πλυντήριο και μπάρμπεκιου.",
            description3:
              "Είτε αναζητάτε περιπέτεια είτε ηρεμία, το Sevasti Country House είναι το ιδανικό σημείο για να εξερευνήσετε τη Βόρεια Ελλάδα.",

            attractions: {
              title: "Αξιοθέατα κοντά μας",

              beach: {
                title: "Παραλία Κατερίνης",
                description:
                  "Δημοφιλής προορισμός μόλις 15 λεπτά μακριά — ιδανικός για κολύμπι, βόλτες στο ηλιοβασίλεμα και φαγητό δίπλα στη θάλασσα.",
              },
              olympus: {
                title: "Όλυμπος",
                description:
                  "Ο πιο θρυλικός ορεινός όγκος της Ελλάδας — τέλειος για πεζοπορία και εξερεύνηση.",
              },
              dion: {
                title: "Αρχαιολογικό Μουσείο Δίου",
                description:
                  "Γνωρίστε την αρχαία Μακεδονία μέσα από τα εκθέματα του μουσείου και τον αρχαιολογικό χώρο.",
              },
              parks: {
                title: "Τοπικά Πάρκα Φύσης",
                description:
                  "Η Σεβαστή περιβάλλεται από φύση — ιδανική για περπάτημα ή χαλάρωση.",
              },
              vergina: {
                title: "Βασιλικοί Τάφοι Βεργίνας",
                description:
                  "Επισκεφθείτε τον τάφο του Φιλίππου Β' της Μακεδονίας — Μνημείο Παγκόσμιας Κληρονομιάς της UNESCO.",
              },
            },
          },
        },
      },
    },
  });

export default i18n;
